import moment from 'moment';

export const validateDate = (value, format) => {
    const date = moment(value, format, true);

    return date.isValid();
};
